import { Navigate, RouterProvider } from 'react-router';
import { TemplateRoute } from '../template-route';
import { Suspense } from 'react';
import { sentryCreateBrowserRouter } from '../../../../instrument';
import { GlobalErrorBoundary } from '../../molecules';
import {
  CodeEditor,
  ContextEditor,
  EntryEditor,
  GraphEditor,
  Setup,
  SchemaEditor,
  StructureSelector,
  GraphErrorBoundary,
} from '@/components';
import { RawEditor } from '../editor';
import { AppLayout } from '../layout/app-layout';
import { applyAuthParamsFromUrl } from './auth-params';

const graphRouter = [
  {
    path: 'graph',
    children: [
      {
        path: ':graphId?',
        errorElement: <GraphErrorBoundary />,
        children: [
          {
            index: true,
            element: <GraphEditor />,
          },
        ],
      },
    ],
  },
];

const codeRouter = [
  {
    path: 'code',
    element: <CodeEditor />,
  },
];

applyAuthParamsFromUrl();

const router = sentryCreateBrowserRouter([
  {
    path: '/',
    errorElement: <GlobalErrorBoundary />,
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <Setup />,
      },
      {
        path: '/editor',
        element: (
          <Suspense>
            <RawEditor />
          </Suspense>
        ),
      },
      {
        path: '/:templateId',
        element: <TemplateRoute />,
        children: [
          {
            path: 'configure',
            element: <SchemaEditor />,
          },
          {
            path: 'entries',
            children: [
              {
                index: true,
                element: <EntryEditor />,
              },
              {
                path: ':entryId',
                children: [
                  ...codeRouter,
                  ...graphRouter,
                  {
                    path: 'context',
                    children: [
                      {
                        index: true,
                        element: <ContextEditor />,
                      },
                      {
                        path: 'structure',
                        element: <StructureSelector />,
                      },
                      {
                        path: ':variableId',
                        children: [...codeRouter, ...graphRouter],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]);

export const App = () => {
  return <RouterProvider router={router} />;
};
